// extracted by mini-css-extract-plugin
export default {"container":"style_container__mYR-g","notification":"style_notification__TggUG"};